'use client'

import { useState, useEffect, useRef, useCallback } from 'react'
import Image from "next/image"
import { Progress } from "@/components/ui/shadcn/progress"

export default function Loader({className, progress, showProgress=false, status}) {
    const [displayed, setDisplayed] = useState(status)
    const [incoming, setIncoming] = useState(null)
    const [phase, setPhase] = useState('idle')
    const timeoutRef = useRef(null)
    const rafRef = useRef(null)

    const cleanup = useCallback(() => {
        clearTimeout(timeoutRef.current)
        cancelAnimationFrame(rafRef.current)
    }, [])

    useEffect(() => {
        if (status === displayed && phase === 'idle') return
        cleanup()

        setIncoming(status)
        setPhase('enter')

        rafRef.current = requestAnimationFrame(() => {
            rafRef.current = requestAnimationFrame(() => {
                setPhase('animate')

                timeoutRef.current = setTimeout(() => {
                    setDisplayed(status)
                    setIncoming(null)
                    setPhase('idle')
                }, 400)
            })
        })

        return cleanup
    }, [status])

    return (
        <div className={`flex justify-center items-center w-full h-full absolute top-0 left-0 bg-background/90 z-50 p-6 backdrop-blur-lg ${className}`}>
            <div className="flex flex-col items-center relative w-full">
                <Image src="/wsc-loader.gif" alt="Loading" width={160} height={160} />
                <div className="flex flex-col items-center gap-8 absolute top-[85%] w-full">
                    <div className="relative w-full text-secondary-foreground text-xs">
                        <span
                            style={{
                                opacity: phase === 'animate' ? 0 : 1,
                                transform: phase === 'animate' ? 'translateY(-10px)' : 'translateY(0)',
                                transition: phase === 'idle' ? 'none' : 'opacity 100ms ease-in-out, transform 200ms ease-out',
                            }}
                            className="absolute inset-0 max-w-md mx-auto text-center"
                        >
                            {displayed}
                        </span>
                        {incoming && (
                            <span
                                style={{
                                    opacity: phase === 'animate' ? 1 : 0,
                                    transform: phase === 'animate' ? 'translateY(0)' : 'translateY(10px)',
                                    transition: phase === 'enter' ? 'none' : 'opacity 100ms ease-in-out 100ms, transform 200ms ease-in-out 100ms',
                                }}
                                className="absolute inset-0 max-w-md mx-auto text-center"
                            >
                                {incoming}
                            </span>
                        )}
                    </div>
                    {showProgress && <Progress value={progress} className='w-56' />}
                </div>
                
            </div>
        </div>
    )
}